import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type InternalUserRow = {
  user_id: string;
  full_name: string | null;
  avatar_url: string | null;
  role_id: string | null;
  email: string | null;
};

// GET /api/admin/users/internal — every internal teammate + their email
// (joined from auth.users) + current role assignment. Drives the Members
// tab on /admin/settings/roles/:id.
export function useInternalUsers() {
  return useQuery<InternalUserRow[], ApiClientError>({
    queryKey: queryKeys.users.internal(),
    queryFn: () => apiFetch<InternalUserRow[]>("/admin/users/internal"),
  });
}
